import func from '@/utils/func';
import axios from 'axios'
import {generateSHA256Sign,generateNonce} from '@/utils/index';
/**
 * 封装axios，实现发送/响应接口的拦截，来实现统一提示等效果
 */

var service = axios.create({
  // baseURL: 'http://fcwash.local.com/',
  baseURL: 'https://fcwash.uunbiot.com/',
  timeout:30000, // 请求超时时间限制
  headers: {'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',token:func.getLocal('token')},
  transformRequest: [function (data) {
    let ret = ''
    for (let it in data) {
      ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
    }
    return ret
  }],
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // func.startLoading()
    if(!config.headers.token) {
      let token = func.getLocal('token')
      config.headers.token = `${token}`;
    }
    if(!config.headers.sign) {
      let data = config.data || config.params;
      const params = {
          timestamp: Date.now(),
          nonce: generateNonce(),
      };
      if (typeof(data) !== 'undefined') {
          for (let key in data) {
              params[key] = data[key];
          }
      }
      config.headers.timestamp = params.timestamp;
      config.headers.nonce = params.nonce;
      config.headers.sign = generateSHA256Sign(params);
    }
    return config
  },
  err => {
    // func.endLoading()
    func.showToast()
    Promise.reject(err)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    // func.endLoading()
    if(response.status == 200){
      if(!response.data.code || response.data.code == 2){
        return response.data
      }else{
        // func.endLoading();
        func.showToast(response.data.msg);
        return false;
      }
    }else{
      func.showToast('系统错误，请稍后再试')
    }
  },
  err => {
    func.showToast('系统错误，请稍后再试');
    return Promise.reject(err)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js